import moment from 'moment-timezone';
import useGraphQLClient from './graphqlClient';
import {
  SortOrder,
  Notices,
  NoticesOrderByWithRelationInput,
  NoticesWhereInput,
  NoticesCreateInput,
} from './spotwrite';

/**
 * お知らせの検索条件
 */
export type NoticesSearchCondition = {
  limit?: number;
  offset?: number;
  orderBy?: NoticesOrderByWithRelationInput[];
};

class NoticeService {
  client = useGraphQLClient();

  /**
   * 検索条件を整形します
   * @param condition
   * @returns
   */
  private buildSearchWhere = (condition: NoticesSearchCondition) => {
    const andWhere: NoticesWhereInput[] = [];

    andWhere.push({
      publish: {
        lte: moment(new Date()).toISOString(),
      },
    });

    // andWhere.push({
    //   disabled: {
    //     gt: moment(new Date()).toISOString(),
    //   },
    // });

    return {
      AND: andWhere,
    };
  }

  /**
   * お知らせを検索
   * @param where
   */
  public async search(condition: NoticesSearchCondition) {
    // 検索条件ビルド
    const where = this.buildSearchWhere(condition);
    try {
      const res = await this.client.findManyNotices({
        where,
        take: condition.limit,
        skip: condition.offset,
        orderBy: {
          publish: SortOrder.Desc,
        },
      });
      return res.findManyNotices as Notices[];
    } catch (error) {
      console.log(error);
    }
    return [];
  }

  /**
   * 指定した検索条件に一致するお知らせの件数を取得
   * @param condition
   * @returns
   */
  public aggregateSearch = async (condition: NoticesSearchCondition) => {
    const client = useGraphQLClient();

    // 検索条件ビルド
    const where = this.buildSearchWhere(condition);

    try {
      const res = await client.aggregateNotices({
        where,
      });
      return res.aggregateNotices?.count;
    } catch (error) {
      console.log(error);
    }
    return null;
  };

  /**
   * 新着お知らせを取得
   * @param limit
   */
  public latest = async (limit: number) => {
    const condition: NoticesSearchCondition = {
      limit: limit > 0 ? limit : 10,
    };
    return this.search(condition);
  }

  /**
   * IDを指定してお知らせを取得します
   * @param id
   * @returns
   */
  public get = async (noticeId: number) => {
    const client = useGraphQLClient();
    try {
      const res = await client.findUniqueNotices({
        where: { id: noticeId },
      });
      return res.findUniqueNotices as Notices;
    } catch (error) {
      console.log(error);
    }
    return null;
  }

  /**
   * お知らせを削除します
   * @param noticeId
   */
  public delete = async (noticeId: number) => {
    const client = useGraphQLClient();
    const notice = await this.get(noticeId);
    if (notice) {
      try {
        const deleted = await client.deleteOneNotices({
          where: { id: notice.id },
        });
        return deleted;
      } catch (error) {
        console.log(error);
      }
    }
    return null;
  }

  /**
   * お知らせを登録します
   * @param production
   */
  public insert = async (data: any) => {
    const client = useGraphQLClient();
    try {
      // 挿入
      const input: NoticesCreateInput = {
        title: data.title,
        description: data.description,
        publish: data.publish,
        // disabled: data.disabled,
      };

      // お知らせを登録
      const res = await client.createOneNotices({
        data: input,
      });
      return res.createOneNotices;
    } catch (error) {
      console.log(error);
    }
    return null;
  };
}
export default new NoticeService();
